// ============================================
// Path: /frontend/src/lib/vehicles.js
// Purpose: COMPREHENSIVE Vehicle makes and models data
// ============================================

export const makes = [
  // ========== JAPANESE BRANDS ==========
  {
    name: 'Toyota',
    models: [
      '4-Runner', 'Alphard', 'Auris', 'Avalon', 'Avensis', 'Axio', 'Belta', 'Blade', 'Camry',
      'Coaster', 'Corolla', 'Corolla Cross', 'Crown', 'Dyna', 'Estima', 'Fielder', 'Fortuner', 
      'Harrier', 'Hiace', 'Hilux', 'Isis', 'Ist', 'Kluger', 'Land Cruiser', 'Mark X', 'Noah', 
      'Passo', 'Porte', 'Prado', 'Premio', 'Probox', 'Ractis', 'Raize', 'RAV4', 'Regius', 
      'Rush', 'Sienta', 'Succeed', 'TownAce', 'Toyoace', 'Vanguard', 'Vellfire', 'Vios', 
      'Vitz', 'Voxy', 'Wish', 'Yaris', 'bZ4X',
    ],
  },
  {
    name: 'Nissan',
    models: [
      '350Z', '370Z', 'AD Van', 'Altima', 'Ariya', 'Bluebird Sylphy', 'Caravan', 'Civilian', 
      'Clipper', 'Cube', 'Dualis', 'Elgrand', 'Fuga', 'Juke', 'Kicks', 'Lafesta', 'Latio', 
      'Leaf', 'March', 'Maxima', 'Murano', 'Navara', 'Note', 'NP200', 'NP300', 'NV200', 
      'NV350', 'Pathfinder', 'Patrol', 'Presage', 'Qashqai', 'Rogue', 'Sentra', 'Serena', 
      'Skyline', 'Teana', 'Tiida', 'Titan', 'Urvan', 'Vanette', 'Versa', 'Wingroad', 'X-Trail',
    ],
  },
  {
    name: 'Honda',
    models: [
      'Accord', 'Airwave', 'Civic', 'City', 'CR-V', 'CR-Z', 'Crossroad', 'e', 'Elysion', 'Fit', 
      'Freed', 'Grace', 'HR-V', 'Insight', 'Inspire', 'Jade', 'Jazz', 'Legend', 'N-Box', 'N-One', 
      'N-Van', 'N-WGN', 'Odyssey', 'Passport', 'Pilot', 'Ridgeline', 'Shuttle', 'Stepwgn', 
      'Stream', 'Vezel', 'ZR-V',
    ],
  },
  {
    name: 'Mazda',
    models: [
      '2', '3', '6', 'Atenza', 'Axela', 'AZ-Wagon', 'Biante', 'Bongo', 'BT-50', 'Carol', 
      'CX-3', 'CX-30', 'CX-5', 'CX-50', 'CX-60', 'CX-7', 'CX-8', 'CX-9', 'CX-90', 'Demio', 
      'Familia', 'Flair', 'MX-30', 'MX-5', 'MPV', 'Premacy', 'RX-8', 'Scrum', 'Titan', 'Verisa',
    ],
  },
  {
    name: 'Subaru',
    models: [
      'Ascent', 'BRZ', 'Crosstrek', 'Dias', 'Exiga', 'Forester', 'Impreza', 'Justy', 'Legacy', 
      'Levorg', 'Outback', 'Pleo', 'R1', 'R2', 'Rex', 'Sambar', 'Solterra', 'Stella', 'Trezia', 
      'Tribeca', 'Vivio', 'WRX', 'XV',
    ],
  },
  {
    name: 'Mitsubishi',
    models: [
      'Airtrek', 'ASX', 'Attrage', 'Canter', 'Colt', 'Delica', 'Diamante', 'Eclipse Cross', 
      'Ek Wagon', 'eK Space', 'eK X', 'Endeavor', 'Fighter', 'Fuso', 'Galant', 'Grandis', 
      'i-MiEV', 'L200', 'L300', 'Lancer', 'Minicab', 'Mirage', 'Montero', 'Outlander', 
      'Pajero', 'Pajero Mini', 'Pajero Sport', 'Rosa', 'RVR', 'Triton', 'Xpander',
    ],
  },
  {
    name: 'Suzuki',
    models: [
      'Alto', 'APV', 'Baleno', 'Carry', 'Celerio', 'Ciaz', 'Dzire', 'Ertiga', 'Escudo', 
      'Every', 'Grand Vitara', 'Hustler', 'Ignis', 'Jimny', 'Kizashi', 'Landy', 'Lapin', 
      'S-Cross', 'S-Presso', 'Solio', 'Spacia', 'Splash', 'Swift', 'SX4', 'Vitara', 
      'Wagon R', 'XBee', 'XL7',
    ],
  },
  {
    name: 'Isuzu',
    models: [
      'Bighorn', 'D-Max', 'Elf', 'F-Series', 'Fargo', 'Forward', 'FRR', 'FSR', 'FTR', 
      'FVR', 'FVZ', 'FXZ', 'Giga', 'Journey', 'MU-X', 'N-Series', 'NPR', 'NQR', 'NKR', 
      'Panther', 'Trooper', 'Wizard',
    ],
  },
  {
    name: 'Daihatsu',
    models: [
      'Ayla', 'Be-Go', 'Boon', 'Cast', 'Copen', 'Cuore', 'Granmax', 'Hijet', 'Luxio', 
      'Materia', 'Max', 'Mira', 'Move', 'Rocky', 'Sirion', 'Taft', 'Tanto', 'Terios', 
      'Thor', 'Xenia', 'Wake',
    ],
  },
  {
    name: 'Lexus',
    models: [
      'CT', 'ES', 'GS', 'GX', 'IS', 'LC', 'LFA', 'LS', 'LX', 'NX', 'RC', 'RX', 'RZ', 
      'TX', 'UX',
    ],
  },
  {
    name: 'Infiniti',
    models: [
      'EX', 'FX', 'G', 'JX', 'M', 'Q30', 'Q45', 'Q50', 'Q60', 'Q70', 'QX30', 'QX4', 
      'QX50', 'QX55', 'QX56', 'QX60', 'QX70', 'QX80',
    ],
  },
  {
    name: 'Acura',
    models: [
      'CL', 'ILX', 'Integra', 'Legend', 'MDX', 'NSX', 'RDX', 'RL', 'RLX', 'RSX', 
      'TL', 'TLX', 'TSX', 'Vigor', 'ZDX',
    ],
  },
  {
    name: 'Hino',
    models: [
      '300 Series', '500 Series', '700 Series', 'Dutro', 'Liesse', 'Profia', 'Ranger', 
      'XZU', 'GD', 'GH', 'RM',
    ],
  },

  // ========== KOREAN BRANDS ==========
  {
    name: 'Hyundai',
    models: [
      'Accent', 'Atos', 'Aura', 'Azera', 'Bayon', 'Creta', 'Elantra', 'Eon', 'Galloper', 
      'Genesis', 'Getz', 'Grand i10', 'Grand Starex', 'H-1', 'H100', 'i10', 'i20', 'i30', 
      'i40', 'Ioniq', 'Ioniq 5', 'Ioniq 6', 'ix20', 'ix35', 'Kona', 'Matrix', 'Mighty', 
      'Nexo', 'Palisade', 'Santa Cruz', 'Santa Fe', 'Santamo', 'Sonata', 'Starex', 
      'Staria', 'Terracan', 'Trajet', 'Tucson', 'Veloster', 'Venue', 'Verna', 'Xcent',
    ],
  },
  {
    name: 'Kia',
    models: [
      'Besta', 'Bongo', 'Cadenza', 'Carens', 'Carnival', 'Ceed', 'Cerato', 'Clarus', 
      'EV6', 'EV9', 'Forte', 'K2500', 'K2700', 'K3', 'K5', 'K7', 'K8', 'K9', 'Mohave', 
      'Niro', 'Opirus', 'Optima', 'Picanto', 'Pregio', 'Rio', 'Sedona', 'Seltos', 
      'Shuma', 'Sorento', 'Soul', 'Spectra', 'Sportage', 'Stinger', 'Stonic', 
      'Telluride', 'Venga',
    ],
  },
  {
    name: 'SsangYong',
    models: [
      'Actyon', 'Korando', 'Kyron', 'Musso', 'Rexton', 'Tivoli', 'XLV',
    ],
  },

  // ========== GERMAN BRANDS ==========
  {
    name: 'Mercedes-Benz',
    models: [
      'A-Class', 'Actros', 'Arocs', 'Atego', 'Axor', 'B-Class', 'C-Class', 'Citan', 'CLA', 
      'CLC', 'CLS', 'E-Class', 'EQA', 'EQB', 'EQC', 'EQE', 'EQS', 'EQV', 'G-Class', 'GL', 
      'GLA', 'GLB', 'GLC', 'GLE', 'GLK', 'GLS', 'ML', 'R-Class', 'S-Class', 'SL', 'SLC', 
      'SLK', 'Sprinter', 'V-Class', 'Vaneo', 'Viano', 'Vito', 'X-Class',
    ],
  },
  {
    name: 'BMW',
    models: [
      '1 Series', '2 Series', '3 Series', '4 Series', '5 Series', '6 Series', '7 Series', 
      '8 Series', 'i3', 'i4', 'i5', 'i7', 'i8', 'iX', 'iX1', 'iX3', 'M2', 'M3', 'M4', 
      'M5', 'M6', 'M8', 'X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'X7', 'Z3', 'Z4', 'Z8',
    ],
  },
  {
    name: 'Audi',
    models: [
      'A1', 'A3', 'A4', 'A4 Allroad', 'A5', 'A6', 'A6 Allroad', 'A7', 'A8', 'e-tron', 
      'e-tron GT', 'Q2', 'Q3', 'Q4 e-tron', 'Q5', 'Q7', 'Q8', 'Q8 e-tron', 'R8', 
      'RS Q3', 'RS Q8', 'RS3', 'RS4', 'RS5', 'RS6', 'RS7', 'RS e-tron GT', 'S3', 'S4', 
      'S5', 'S6', 'S7', 'S8', 'TT', 'TTS',
    ],
  },
  {
    name: 'Volkswagen',
    models: [
      'Amarok', 'Arteon', 'Beetle', 'Bora', 'Caddy', 'California', 'Caravelle', 'CC', 
      'Crafter', 'CrossFox', 'Eos', 'Fox', 'Golf', 'ID.3', 'ID.4', 'ID.5', 'ID.7', 
      'ID.Buzz', 'Jetta', 'Lupo', 'Passat', 'Phaeton', 'Polo', 'Saveiro', 'Scirocco', 
      'Sharan', 'T-Cross', 'T-Roc', 'Taigo', 'Tiguan', 'Touareg', 'Touran', 'Transporter', 
      'Up!', 'Vento',
    ],
  },
  {
    name: 'Porsche',
    models: [
      '718 Boxster', '718 Cayman', '911', 'Cayenne', 'Cayman', 'Macan', 'Panamera', 
      'Taycan',
    ],
  },
  {
    name: 'Opel',
    models: [
      'Adam', 'Agila', 'Ampera', 'Antara', 'Astra', 'Combo', 'Corsa', 'Crossland', 
      'Frontera', 'Grandland', 'Insignia', 'Karl', 'Meriva', 'Mokka', 'Movano', 
      'Omega', 'Tigra', 'Vectra', 'Vivaro', 'Zafira',
    ],
  },

  // ========== AMERICAN BRANDS ==========
  {
    name: 'Ford',
    models: [
      'Bronco', 'Bronco Sport', 'EcoSport', 'Edge', 'Endeavour', 'Escape', 'Everest', 
      'Expedition', 'Explorer', 'F-150', 'F-150 Lightning', 'F-250', 'F-350', 'F-450', 
      'Fiesta', 'Flex', 'Focus', 'Fusion', 'Galaxy', 'Ka', 'Kuga', 'Maverick', 'Mondeo', 
      'Mustang', 'Mustang Mach-E', 'Ranger', 'S-Max', 'Taurus', 'Territory', 'Transit', 
      'Transit Connect', 'Transit Custom',
    ],
  },
  {
    name: 'Chevrolet',
    models: [
      'Aveo', 'Blazer', 'Bolt EUV', 'Bolt EV', 'Camaro', 'Captiva', 'Cavalier', 'Colorado', 
      'Corvette', 'Cruze', 'Equinox', 'Express', 'Groove', 'Impala', 'Malibu', 'Montana', 
      'Onix', 'Orlando', 'Silverado 1500', 'Silverado 2500HD', 'Silverado 3500HD', 'Sonic', 
      'Spark', 'Spin', 'Suburban', 'Tahoe', 'Tornado', 'Trailblazer', 'Traverse', 'Trax', 
      'Volt',
    ],
  },
  {
    name: 'GMC',
    models: [
      'Acadia', 'Canyon', 'Hummer EV', 'Jimmy', 'Savana', 'Sierra 1500', 'Sierra 2500HD', 
      'Sierra 3500HD', 'Terrain', 'Yukon', 'Yukon XL',
    ],
  },
  {
    name: 'Dodge',
    models: [
      'Avenger', 'Caliber', 'Challenger', 'Charger', 'Dakota', 'Dart', 'Durango', 'Grand Caravan', 
      'Journey', 'Nitro', 'Ram 1500', 'Ram 2500', 'Ram 3500', 'Ram 4500', 'Ram 5500',
    ],
  },
  {
    name: 'Jeep',
    models: [
      'Cherokee', 'Commander', 'Compass', 'Gladiator', 'Grand Cherokee', 'Grand Wagoneer', 
      'Liberty', 'Patriot', 'Renegade', 'Wagoneer', 'Wrangler',
    ],
  },
  {
    name: 'Cadillac',
    models: [
      'ATS', 'CT4', 'CT5', 'CT6', 'CTS', 'DTS', 'Escalade', 'Lyriq', 'SRX', 'STS', 
      'XLR', 'XT4', 'XT5', 'XT6',
    ],
  },
  {
    name: 'Lincoln',
    models: [
      'Aviator', 'Continental', 'Corsair', 'MKC', 'MKS', 'MKT', 'MKX', 'MKZ', 'Nautilus', 
      'Navigator', 'Town Car',
    ],
  },
  {
    name: 'Buick',
    models: [
      'Enclave', 'Encore', 'Encore GX', 'Envision', 'LaCrosse', 'Regal', 'Verano',
    ],
  },
  {
    name: 'Chrysler',
    models: [
      '300', 'Aspen', 'Pacifica', 'PT Cruiser', 'Sebring', 'Town & Country', 'Voyager',
    ],
  },
  {
    name: 'Tesla',
    models: [
      'Cybertruck', 'Model 3', 'Model S', 'Model X', 'Model Y', 'Roadster', 'Semi',
    ],
  },
  {
    name: 'Rivian',
    models: [
      'R1S', 'R1T',
    ],
  },
  {
    name: 'Lucid',
    models: [
      'Air', 'Gravity',
    ],
  },

  // ========== BRITISH BRANDS ==========
  {
    name: 'Land Rover',
    models: [
      'Defender', 'Defender 90', 'Defender 110', 'Defender 130', 'Discovery', 'Discovery 1', 
      'Discovery 2', 'Discovery 3', 'Discovery 4', 'Discovery 5', 'Discovery Sport', 
      'Freelander', 'Freelander 2', 'Range Rover', 'Range Rover Classic', 'Range Rover Evoque', 
      'Range Rover Sport', 'Range Rover Velar',
    ],
  },
  {
    name: 'Jaguar',
    models: [
      'E-Pace', 'F-Pace', 'F-Type', 'I-Pace', 'S-Type', 'X-Type', 'XE', 'XF', 'XJ', 
      'XK', 'XKR',
    ],
  },
  {
    name: 'Bentley',
    models: [
      'Bentayga', 'Continental', 'Continental GT', 'Flying Spur', 'Mulsanne',
    ],
  },
  {
    name: 'Rolls-Royce',
    models: [
      'Cullinan', 'Dawn', 'Ghost', 'Phantom', 'Spectre', 'Wraith',
    ],
  },
  {
    name: 'Aston Martin',
    models: [
      'DB9', 'DB11', 'DB12', 'DBS', 'DBX', 'Rapide', 'Vantage', 'Vanquish',
    ],
  },
  {
    name: 'McLaren',
    models: [
      '540C', '570S', '600LT', '620R', '650S', '675LT', '720S', '765LT', 'Artura', 'GT', 'P1',
    ],
  },
  {
    name: 'Lotus',
    models: [
      'Eletre', 'Elise', 'Emira', 'Evora', 'Exige',
    ],
  },
  {
    name: 'Mini',
    models: [
      'Clubman', 'Countryman', 'Coupe', 'Hatch', 'John Cooper Works', 'Paceman', 'Roadster',
    ],
  },

  // ========== FRENCH BRANDS ==========
  {
    name: 'Renault',
    models: [
      'Arkana', 'Captur', 'Clio', 'Duster', 'Express', 'Fluence', 'Kadjar', 'Kangoo', 
      'Koleos', 'Kwid', 'Logan', 'Master', 'Megane', 'Sandero', 'Scenic', 'Symbol', 
      'Talisman', 'Trafic', 'Triber', 'Twingo', 'Zoe',
    ],
  },
  {
    name: 'Peugeot',
    models: [
      '108', '2008', '208', '3008', '308', '4007', '4008', '5008', '508', 'Boxer', 
      'e-2008', 'e-208', 'Expert', 'Landtrek', 'Partner', 'RCZ', 'Rifter', 'Traveller',
    ],
  },
  {
    name: 'Citroën',
    models: [
      'Berlingo', 'C1', 'C3', 'C3 Aircross', 'C4', 'C4 Cactus', 'C4 Picasso', 'C5', 
      'C5 Aircross', 'C5 X', 'C8', 'Dispatch', 'DS3', 'DS4', 'DS5', 'Jumper', 'Jumpy', 
      'Nemo', 'Relay', 'SpaceTourer', 'Xsara Picasso',
    ],
  },
  {
    name: 'DS',
    models: [
      'DS 3', 'DS 3 Crossback', 'DS 4', 'DS 7', 'DS 9',
    ],
  },

  // ========== ITALIAN BRANDS ==========
  {
    name: 'Fiat',
    models: [
      '124 Spider', '500', '500C', '500e', '500L', '500X', 'Bravo', 'Doblo', 'Ducato', 
      'Fiorino', 'Freemont', 'Fullback', 'Grande Punto', 'Idea', 'Linea', 'Multipla', 
      'Panda', 'Palio', 'Punto', 'Qubo', 'Scudo', 'Sedici', 'Siena', 'Stilo', 'Strada', 
      'Toro', 'Tipo', 'Uno',
    ],
  },
  {
    name: 'Alfa Romeo',
    models: [
      '147', '156', '159', '166', '4C', 'Brera', 'Giulia', 'Giulietta', 'GT', 'GTV', 
      'Mito', 'Spider', 'Stelvio', 'Tonale',
    ],
  },
  {
    name: 'Lancia',
    models: [
      'Delta', 'Musa', 'Phedra', 'Thema', 'Ypsilon',
    ],
  },
  {
    name: 'Ferrari',
    models: [
      '296 GTB', '296 GTS', '458', '488', '812', 'California', 'F12', 'F8', 'FF', 
      'GTC4Lusso', 'LaFerrari', 'Portofino', 'Roma', 'SF90', 'Superfast',
    ],
  },
  {
    name: 'Lamborghini',
    models: [
      'Aventador', 'Gallardo', 'Huracan', 'Revuelto', 'Urus',
    ],
  },
  {
    name: 'Maserati',
    models: [
      'Ghibli', 'GranCabrio', 'GranTurismo', 'Grecale', 'Levante', 'MC20', 'Quattroporte',
    ],
  },

  // ========== SWEDISH BRANDS ==========
  {
    name: 'Volvo',
    models: [
      'C30', 'C40', 'C70', 'EX30', 'EX90', 'FE', 'FH', 'FH16', 'FL', 'FM', 'FMX', 
      'S40', 'S60', 'S80', 'S90', 'V40', 'V50', 'V60', 'V70', 'V90', 'XC40', 'XC60', 
      'XC70', 'XC90',
    ],
  },
  {
    name: 'Saab',
    models: [
      '9-3', '9-5', '9-7X',
    ],
  },
  {
    name: 'Polestar',
    models: [
      'Polestar 2', 'Polestar 3', 'Polestar 4',
    ],
  },
  {
    name: 'Scania',
    models: [
      'G-Series', 'L-Series', 'P-Series', 'R-Series', 'S-Series', 'XT',
    ],
  },

  // ========== CZECH & SPANISH BRANDS ==========
  {
    name: 'Skoda',
    models: [
      'Citigo', 'Enyaq', 'Fabia', 'Kamiq', 'Karoq', 'Kodiaq', 'Octavia', 'Rapid', 
      'Roomster', 'Scala', 'Superb', 'Yeti',
    ],
  },
  {
    name: 'SEAT',
    models: [
      'Alhambra', 'Altea', 'Arona', 'Ateca', 'Ibiza', 'Leon', 'Mii', 'Tarraco', 'Toledo',
    ],
  },
  {
    name: 'Cupra',
    models: [
      'Ateca', 'Born', 'Formentor', 'Leon',
    ],
  },

  // ========== CHINESE BRANDS - PASSENGER ==========
  {
    name: 'BYD',
    models: [
      'Atto 3', 'Dolphin', 'e2', 'e3', 'e6', 'F0', 'F3', 'G6', 'Han', 'Qin', 'S6', 
      'Seal', 'Song', 'Song Max', 'Song Plus', 'Tang', 'Yuan Plus',
    ],
  },
  {
    name: 'Chery',
    models: [
      'Amulet', 'Arrizo 3', 'Arrizo 5', 'Arrizo 6', 'Arrizo 7', 'Arrizo 8', 'eQ', 
      'Fulwin 2', 'Omoda 5', 'QQ', 'QQ3', 'Tiggo 2', 'Tiggo 3', 'Tiggo 3X', 'Tiggo 4', 
      'Tiggo 4 Pro', 'Tiggo 5', 'Tiggo 5X', 'Tiggo 7', 'Tiggo 7 Pro', 'Tiggo 8', 
      'Tiggo 8 Pro', 'Tiggo 8 Pro Max',
    ],
  },
  {
    name: 'Geely',
    models: [
      'Azkarra', 'Binrui', 'Binyue', 'Boyue', 'Coolray', 'Emgrand', 'Emgrand 7', 
      'Emgrand EC7', 'Emgrand GL', 'Emgrand GS', 'Emgrand GT', 'Emgrand X7', 'Galaxy', 
      'Geometry A', 'Geometry C', 'Monjaro', 'Okavango', 'Panda', 'Preface', 'Tugella', 
      'Vision',
    ],
  },
  {
    name: 'Great Wall',
    models: [
      'C30', 'Cowry', 'Florid', 'Haval Big Dog', 'Haval Dargo', 'Haval F7', 'Haval H2', 
      'Haval H6', 'Haval H9', 'Haval Jolion', 'Haval M6', 'Ora Good Cat', 'Ora Funky Cat', 
      'Pao', 'Poer', 'Poer King Kong', 'Voleex C10', 'Voleex C30', 'Wingle 5', 'Wingle 6', 
      'Wingle 7',
    ],
  },
  {
    name: 'MG',
    models: [
      'HS', 'Marvel R', 'MG3', 'MG4 EV', 'MG5', 'MG5 EV', 'MG6', 'MG7', 'MG ZS', 
      'MG ZS EV', 'RX5',
    ],
  },
  {
    name: 'JAC',
    models: [
      'iEV6S', 'iEV7', 'iEV7S', 'J3', 'J4', 'J5', 'J7', 'JS3', 'JS4', 'Refine', 
      'Rein', 'S2', 'S3', 'S4', 'S5', 'S7', 'T6', 'T8', 'T9',
    ],
  },
  {
    name: 'Changan',
    models: [
      'Alsvin', 'Benni', 'CX20', 'CX30', 'CS15', 'CS35', 'CS35 Plus', 'CS55', 
      'CS55 Plus', 'CS75', 'CS75 Plus', 'CS85', 'CS95', 'Deepal S7', 'Eado', 
      'Eado Plus', 'Eado XT', 'Hunter', 'Raeton', 'Uni-K', 'Uni-T', 'Uni-V',
    ],
  },
  {
    name: 'Haval',
    models: [
      'Big Dog', 'Dargo', 'F5', 'F7', 'F7X', 'H2', 'H4', 'H5', 'H6', 'H7', 'H9', 
      'Jolion', 'M6',
    ],
  },
  {
    name: 'Hongqi',
    models: [
      'E-HS3', 'E-HS9', 'E-QM5', 'H5', 'H7', 'H9', 'HS3', 'HS5', 'HS7', 'L5',
    ],
  },
  {
    name: 'Dongfeng',
    models: [
      'AX3', 'AX4', 'AX5', 'AX7', 'Rich', 'S30', 'S50', 'T5 EVO',
    ],
  },
  {
    name: 'BAIC',
    models: [
      'BJ20', 'BJ40', 'BJ80', 'D20', 'D50', 'EC Series', 'EC180', 'EC200', 'EU Series', 
      'EU260', 'EU5', 'EX Series', 'EX200', 'EX360', 'Senova D50', 'Senova D70', 
      'X25', 'X35', 'X55', 'X65', 'X7',
    ],
  },
  {
    name: 'SAIC',
    models: [
      'Maxus D60', 'Maxus D90', 'Maxus G10', 'Maxus G50', 'Maxus T60', 'Maxus T70', 
      'Maxus T90', 'Maxus V80', 'Maxus V90', 'Roewe i5', 'Roewe i6', 'Roewe RX3', 
      'Roewe RX5', 'Roewe RX8',
    ],
  },
  {
    name: 'Wuling',
    models: [
      'Almaz', 'Confero', 'Cortez', 'Hongguang', 'Hongguang Mini EV', 'Hongguang S', 
      'Hongguang S3', 'Journey',
    ],
  },
  {
    name: 'GAC',
    models: [
      'Aion LX', 'Aion S', 'Aion V', 'Aion Y', 'GS3', 'GS4', 'GS5', 'GS7', 'GS8', 
      'Trumpchi GA3', 'Trumpchi GA4', 'Trumpchi GA5', 'Trumpchi GA6', 'Trumpchi GA8', 
      'Trumpchi GM6', 'Trumpchi GM8', 'Trumpchi GN6', 'Trumpchi GN8',
    ],
  },
  {
    name: 'Nio',
    models: [
      'EC6', 'EC7', 'ES6', 'ES7', 'ES8', 'ET5', 'ET7',
    ],
  },
  {
    name: 'XPeng',
    models: [
      'G3', 'G6', 'G9', 'P5', 'P7', 'X9',
    ],
  },
  {
    name: 'Li Auto',
    models: [
      'Li L6', 'Li L7', 'Li L8', 'Li L9', 'Li One',
    ],
  },
  {
    name: 'Lynk & Co',
    models: [
      '01', '02', '03', '05', '06', '09',
    ],
  },
  {
    name: 'Aiways',
    models: [
      'U5', 'U6',
    ],
  },
  {
    name: 'WEY',
    models: [
      'VV5', 'VV6', 'VV7',
    ],
  },
  {
    name: 'Jetour',
    models: [
      'Dashing', 'X70', 'X70 Plus', 'X90', 'X95',
    ],
  },
  {
    name: 'Voyah',
    models: [
      'Dreamer', 'Free',
    ],
  },
  {
    name: 'Seres',
    models: [
      'SF5', 'SF7',
    ],
  },
  {
    name: 'Zeekr',
    models: [
      '001', '009', 'X',
    ],
  },
  {
    name: 'Leap Motor',
    models: [
      'C01', 'C11', 'T03',
    ],
  },
  {
    name: 'Neta',
    models: [
      'Neta S', 'Neta U', 'Neta V',
    ],
  },

  // ========== CHINESE TRUCKS & COMMERCIAL ==========
  {
    name: 'HOWO',
    models: [
      'A7', 'T5G', 'T7H', 'Cargo Truck 4x2', 'Cargo Truck 6x4', 'Cargo Truck 8x4', 
      'Concrete Mixer 6x4', 'Concrete Mixer 8x4', 'Dump Truck 4x2', 'Dump Truck 6x4', 
      'Dump Truck 8x4', 'Fuel Tanker', 'Tractor Head 4x2', 'Tractor Head 6x4', 
      'Water Tanker', 'Wrecker',
    ],
  },
  {
    name: 'Sinotruk',
    models: [
      'HOWO A7', 'HOWO T5G', 'HOWO T7H', 'HOWO ZZ', 'SITRAK C7H', 'SITRAK G7', 
      'Cargo Truck', 'Concrete Mixer', 'Dump Truck', 'Tractor Head',
    ],
  },
  {
    name: 'Shacman',
    models: [
      'Delong F2000', 'Delong F3000', 'Delong M3000', 'Delong X3000', 'Delong X5000', 
      'Delong X6000', 'H3000', 'L3000', 'Cargo Truck', 'Concrete Mixer', 'Dump Truck', 
      'Tractor Head', 'Water Tanker',
    ],
  },
  {
    name: 'Beiben',
    models: [
      'NG80', 'PowerStar', 'V3', 'Cargo Truck 4x2', 'Cargo Truck 6x2', 'Cargo Truck 6x4', 
      'Cargo Truck 8x4', 'Concrete Mixer', 'Dump Truck 6x4', 'Dump Truck 8x4', 
      'Fuel Tanker', 'Tractor Head 4x2', 'Tractor Head 6x4', 'Water Tanker',
    ],
  },
  {
    name: 'FAW Jiefang',
    models: [
      'J5P', 'J6L', 'J6M', 'J6P', 'J7', 'JH6', 'Tiger V', 'Box Truck', 'Cargo Truck', 
      'Dump Truck', 'Flatbed Truck', 'Refrigerated Truck', 'Tractor Head', 'Van Truck',
    ],
  },
  {
    name: 'Foton',
    models: [
      'Auman', 'Auman EST', 'Auman ETX', 'Auman GTL', 'Aumark', 'Ollin', 'Sauvana', 
      'Thunder', 'Toano', 'Tornado', 'Tunland', 'View', 'Cargo Truck', 'Dump Truck', 
      'Light Truck', 'Mini Truck', 'Van',
    ],
  },
  {
    name: 'CAMC',
    models: [
      'Hanma H3', 'Hanma H6', 'Hanma H7', 'Hanma H9', 'Star', 'Star II', 'Star III', 
      'Cargo Truck', 'Concrete Mixer', 'Dump Truck', 'Tractor Head',
    ],
  },
  {
    name: 'Dayun',
    models: [
      'CGC', 'N6', 'N8', 'N9', 'Cargo Truck', 'Dump Truck', 'Light Truck', 'Van',
    ],
  },
  {
    name: 'JMC',
    models: [
      'Baodian', 'Carrying', 'Kairui', 'N-Series', 'N720', 'N800', 'N900', 'Teshun', 
      'Vigus', 'Boarding', 'Box Truck', 'Cargo Truck', 'Light Truck', 'Pickup', 'Van',
    ],
  },
  {
    name: 'Yuejin',
    models: [
      'NJ1028', 'NJ1041', 'NJ1080', 'Cargo Van', 'Light Truck', 'Mini Truck',
    ],
  },
  {
    name: 'Auman',
    models: [
      'EST-A', 'EST-M', 'ETX', 'GTL', 'Cargo Truck', 'Concrete Mixer', 'Dump Truck', 
      'Tractor Head',
    ],
  },
  {
    name: 'XCMG',
    models: [
      'Hanvan', 'Hummer', 'Cargo Truck', 'Crane Truck', 'Dump Truck', 'Mixer Truck',
    ],
  },
  {
    name: 'Sany',
    models: [
      'Concrete Mixer', 'Crane Truck', 'Dump Truck', 'Pump Truck',
    ],
  },
  {
    name: 'Zoomlion',
    models: [
      'Concrete Mixer', 'Crane Truck', 'Dump Truck', 'Pump Truck',
    ],
  },
  {
    name: 'Hualing',
    models: [
      'Cargo Truck', 'Dump Truck', 'Tractor Head',
    ],
  },
  {
    name: 'CIMC',
    models: [
      'Box Trailer', 'Container Trailer', 'Curtain Side Trailer', 'Flatbed Trailer', 
      'Fuel Tanker Trailer', 'Lowbed Trailer', 'Skeletal Trailer', 'Tipper Trailer',
    ],
  },
  {
    name: 'Haima',
    models: [
      '7X', 'M3', 'M6', 'S5', 'S7',
    ],
  },
  {
    name: 'Maxus',
    models: [
      'Deliver 3', 'Deliver 9', 'eDeliver 3', 'eDeliver 9', 'G10', 'G50', 'T60', 
      'T70', 'T90', 'V80', 'V90',
    ],
  },

  // ========== CHINESE BUS MANUFACTURERS ==========
  {
    name: 'Yutong',
    models: [
      'ZK6107', 'ZK6116', 'ZK6122', 'ZK6127', 'ZK6147', 'City Bus', 'Coach', 
      'Electric Bus', 'School Bus', 'Tourist Bus',
    ],
  },
  {
    name: 'King Long',
    models: [
      'XMQ6112', 'XMQ6119', 'XMQ6127', 'XMQ6129', 'City Bus', 'Coach', 'School Bus', 
      'Tourist Bus',
    ],
  },
  {
    name: 'Golden Dragon',
    models: [
      'XML6102', 'XML6112', 'XML6122', 'XML6125', 'XML6127', 'City Bus', 'Coach', 
      'Tourist Bus',
    ],
  },
  {
    name: 'Higer',
    models: [
      'KLQ6109', 'KLQ6119', 'KLQ6122', 'KLQ6125', 'KLQ6129', 'City Bus', 'Luxury Coach', 
      'Tourist Bus',
    ],
  },
  {
    name: 'Ankai',
    models: [
      'HFF6110', 'HFF6120', 'HFF6121', 'HFF6127', 'City Bus', 'Tourist Bus',
    ],
  },
  {
    name: 'Sunlong',
    models: [
      'SLK6108', 'SLK6109', 'SLK6118', 'SLK6129', 'City Bus', 'School Bus',
    ],
  },
  {
    name: 'Zhongtong',
    models: [
      'LCK6108', 'LCK6109', 'LCK6119', 'LCK6127', 'City Bus', 'Electric Bus',
    ],
  },

  // ========== MALAYSIAN & SOUTHEAST ASIAN ==========
  {
    name: 'Proton',
    models: [
      'Exora', 'Gen-2', 'Iriz', 'Perdana', 'Persona', 'Preve', 'Saga', 'Satria', 
      'Savvy', 'Suprima', 'Waja', 'X50', 'X70', 'X90',
    ],
  },
  {
    name: 'Perodua',
    models: [
      'Alza', 'Aruz', 'Axia', 'Bezza', 'Kelisa', 'Kenari', 'Kembara', 'Myvi', 
      'Nautica', 'Rusa', 'Viva',
    ],
  },

  // ========== INDIAN BRANDS ==========
  {
    name: 'Tata',
    models: [
      '207', 'Ace', 'Aria', 'Bolt', 'Harrier', 'Hexa', 'Indica', 'Indigo', 'Magic', 
      'Nano', 'Nexon', 'Prima', 'Punch', 'Safari', 'Sumo', 'Tiago', 'Tigor', 
      'Venture', 'Winger', 'Xenon', 'Zest',
    ],
  },
  {
    name: 'Mahindra',
    models: [
      'Alfa', 'Alturas', 'Armada', 'Bolero', 'Bolero Neo', 'CJ', 'Commander', 
      'Genio', 'Jeeto', 'KUV100', 'Loadking', 'Marazzo', 'Marshal', 'Maxximo', 
      'Pik-Up', 'Quanto', 'Scorpio', 'Scorpio N', 'Supro', 'Thar', 'TUV300', 
      'Verito', 'XUV300', 'XUV400', 'XUV500', 'XUV700', 'Xylo',
    ],
  },
  {
    name: 'Ashok Leyland',
    models: [
      'Boss', 'Captain', 'Cheetah', 'Dost', 'Ecomet', 'Guru', 'Lynx', 'Partner', 
      'U-Truck', 'Viking',
    ],
  },
  {
    name: 'Eicher',
    models: [
      'Pro 1049', 'Pro 1059', 'Pro 1080', 'Pro 1095', 'Pro 2049', 'Pro 2059', 
      'Pro 2095', 'Pro 3009', 'Pro 3015', 'Pro 6016', 'Pro 6019', 'Skyline',
    ],
  },
  {
    name: 'Force Motors',
    models: [
      'Gurkha', 'One', 'Traveller', 'Trax',
    ],
  },

  // ========== EUROPEAN TRUCKS ==========
  {
    name: 'MAN',
    models: [
      'Lion\'s City', 'Lion\'s Coach', 'TGA', 'TGE', 'TGL', 'TGM', 'TGS', 'TGX',
    ],
  },
  {
    name: 'DAF',
    models: [
      'CF', 'LF', 'XD', 'XF', 'XG', 'XG+',
    ],
  },
  {
    name: 'Iveco',
    models: [
      'Daily', 'Eurocargo', 'S-Way', 'Stralis', 'T-Way', 'Trakker', 'X-Way',
    ],
  },
  {
    name: 'Renault Trucks',
    models: [
      'C', 'D', 'K', 'Master', 'T',
    ],
  },
  {
    name: 'UD Trucks',
    models: [
      'Condor', 'Croner', 'Quester', 'Quon',
    ],
  },

  // ========== OTHER NOTABLE BRANDS ==========
  {
    name: 'Smart',
    models: [
      'EQ Forfour', 'Forfour', 'Fortwo',
    ],
  },
  {
    name: 'Alpine',
    models: [
      'A110',
    ],
  },
  {
    name: 'Bugatti',
    models: [
      'Chiron', 'Veyron',
    ],
  },
  {
    name: 'Koenigsegg',
    models: [
      'Agera', 'Gemera', 'Jesko', 'Regera',
    ],
  },
  {
    name: 'Pagani',
    models: [
      'Huayra', 'Zonda',
    ],
  },
  {
    name: 'Morgan',
    models: [
      'Plus Four', 'Plus Six',
    ],
  },
  {
    name: 'Dacia',
    models: [
      'Dokker', 'Duster', 'Jogger', 'Lodgy', 'Logan', 'Sandero', 'Spring',
    ],
  },
  {
    name: 'Lada',
    models: [
      'Granta', 'Largus', 'Niva', 'Vesta', 'XRAY',
    ],
  },
  {
    name: 'UAZ',
    models: [
      'Hunter', 'Patriot', 'Pickup',
    ],
  },
  {
    name: 'Brilliance',
    models: [
      'V3', 'V5', 'V6', 'V7',
    ],
  },
  {
    name: 'Zotye',
    models: [
      'T300', 'T500', 'T600', 'T700', 'Z100', 'Z300', 'Z500',
    ],
  },
  {
    name: 'Lifan',
    models: [
      '520', '620', '720', 'X50', 'X60', 'X70',
    ],
  },
  {
    name: 'Changhe',
    models: [
      'A6', 'Q25', 'Q35',
    ],
  },
  {
    name: 'Soueast',
    models: [
      'DX3', 'DX5', 'DX7',
    ],
  },
  {
    name: 'Hafei',
    models: [
      'Lobo', 'Saibao', 'Simbo',
    ],
  },
  {
    name: 'Gonow',
    models: [
      'GA200', 'GX6', 'Troy',
    ],
  },
  {
    name: 'Hawtai',
    models: [
      'Boliger', 'Santa Fe',
    ],
  },
  {
    name: 'Karry',
    models: [
      'Q22', 'Q50',
    ],
  },
  {
    name: 'Landwind',
    models: [
      'X2', 'X5', 'X6', 'X7', 'X8', 'X9',
    ],
  },
];

// Calculate statistics
const totalModels = makes.reduce((sum, make) => sum + make.models.length, 0);
const makesByRegion = {
  Japanese: makes.filter(m => ['Toyota', 'Nissan', 'Honda', 'Mazda', 'Subaru', 'Mitsubishi', 'Suzuki', 'Isuzu', 'Daihatsu', 'Lexus', 'Infiniti', 'Acura', 'Hino'].includes(m.name)).length,
  Korean: makes.filter(m => ['Hyundai', 'Kia', 'SsangYong'].includes(m.name)).length,
  Chinese: makes.filter(m => ['BYD', 'Chery', 'Geely', 'Great Wall', 'MG', 'JAC', 'Changan', 'Haval', 'Hongqi', 'Dongfeng', 'BAIC', 'SAIC', 'Wuling', 'GAC', 'Nio', 'XPeng', 'Li Auto', 'HOWO', 'Sinotruk', 'Shacman', 'Beiben', 'FAW Jiefang', 'Foton', 'CAMC', 'Dayun', 'JMC', 'Yutong', 'King Long', 'Golden Dragon', 'Higer'].includes(m.name)).length,
  European: makes.filter(m => ['Mercedes-Benz', 'BMW', 'Audi', 'Volkswagen', 'Porsche', 'Opel', 'Volvo', 'Polestar', 'Scania', 'Skoda', 'SEAT', 'Renault', 'Peugeot', 'Citroën', 'Fiat', 'Alfa Romeo', 'Ferrari', 'Lamborghini', 'Maserati', 'Land Rover', 'Jaguar', 'Bentley', 'Rolls-Royce', 'MAN', 'DAF', 'Iveco'].includes(m.name)).length,
  American: makes.filter(m => ['Ford', 'Chevrolet', 'GMC', 'Dodge', 'Jeep', 'Cadillac', 'Lincoln', 'Buick', 'Chrysler', 'Tesla', 'Rivian', 'Lucid'].includes(m.name)).length,
};

console.log('='.repeat(60));
console.log('[vehicles.js] COMPLETE VEHICLE DATABASE LOADED');
console.log('='.repeat(60));
console.log(`Total Makes: ${makes.length}`);
console.log(`Total Models: ${totalModels}`);
console.log('\nBreakdown by Region:');
console.log(`  Japanese Brands: ${makesByRegion.Japanese}`);
console.log(`  Korean Brands: ${makesByRegion.Korean}`);
console.log(`  Chinese Brands: ${makesByRegion.Chinese}`);
console.log(`  European Brands: ${makesByRegion.European}`);
console.log(`  American Brands: ${makesByRegion.American}`);
console.log('='.repeat(60));

// Detailed logging
makes.forEach(make => {
  console.log(`[vehicles.js] ${make.name}: ${make.models.length} models`);
});